import { useQuery } from '@tanstack/react-query';
import { fetchApi } from '../../../../lib/fetchApi';
import { QueryConfig, ExtractFnReturnType } from '../../../../lib/react-query';
import i18n from '../../../../i18n';
import { SelectItemDto } from '../../../../types/SelectItemDto';


export const getClaimProfessionalTypeSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/claimProfessionalType/select`) as SelectItemDto[];
  return response;
}

type QueryFnType = typeof getClaimProfessionalTypeSelect;

type UseClaimProfessionalTypeSelectOptions = { 
  config?: QueryConfig<QueryFnType>;
};

export const useClaimProfessionalTypeSelect = ({ config = {} }: UseClaimProfessionalTypeSelectOptions) => {
    return useQuery<ExtractFnReturnType<QueryFnType>>({
        ...config,
        queryKey: ['claimProfessionalTypeSelect', i18n.language],
        queryFn: () => getClaimProfessionalTypeSelect(), //
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });
};